import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar/navbar";
import Footer from "./components/Footer/footer";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import About from "./pages/About";
import LaserEngraving from "./pages/laser-engraving";
import Knives from "./pages/knives";
import ProductDetails from "./pages/ProductDetails";
import SearchPage from "./pages/SearchPage"; // Import SearchPage component

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-gradient-to-t from-gray-800 to-gray-900 text-white font-momo">
        <Navbar />
        <main className="flex-grow container mx-auto px-4 py-8">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/about" element={<About />} />
            <Route path="/laser-engraving" element={<LaserEngraving />} />
            <Route path="/knives" element={<Knives />} />
            <Route path="/product/:id" element={<ProductDetails />} />
            <Route path="/search" element={<SearchPage />} /> 
            <Route path="*" element={<h1>404: Page Not Found</h1>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;